// src/Register.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from './AuthContext';

function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [role, setRole] = useState('Farmer');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      await register(email, password, role, null);
      
      // Role-based routing
      if (role === 'Admin') {
        navigate('/admin');
      } else if (role === 'Validator') {
        navigate('/validator');
      } else if (role === 'Coordinator') {
        navigate('/coordinator');
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0f2419',
      padding: '20px'
    }}>
      <div style={{
        background: '#1a3327',
        padding: '40px',
        borderRadius: '8px',
        border: '1px solid #2d5a45',
        maxWidth: '400px',
        width: '100%'
      }}>
        <h1 style={{ color: 'white', marginBottom: '10px' }}>Create Account</h1>
        <p style={{ color: '#888', marginBottom: '30px', fontSize: '14px' }}>
          Join AgroConnect
        </p>
        
        {error && (
          <div style={{
            background: '#ef4444',
            color: 'white',
            padding: '12px',
            borderRadius: '4px',
            marginBottom: '20px',
            fontSize: '14px'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ 
              display: 'block', 
              color: '#a0a0a0', 
              marginBottom: '8px',
              fontSize: '14px'
            }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              style={{
                width: '100%',
                padding: '12px',
                background: '#0f2419',
                border: '1px solid #2d5a45',
                borderRadius: '4px',
                color: 'white',
                fontSize: '16px'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ 
              display: 'block', 
              color: '#a0a0a0', 
              marginBottom: '8px',
              fontSize: '14px'
            }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="At least 6 characters"
              required
              style={{
                width: '100%',
                padding: '12px',
                background: '#0f2419',
                border: '1px solid #2d5a45',
                borderRadius: '4px',
                color: 'white',
                fontSize: '16px'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ 
              display: 'block', 
              color: '#a0a0a0', 
              marginBottom: '8px',
              fontSize: '14px'
            }}>
              Confirm Password
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Re-enter password"
              required
              style={{
                width: '100%',
                padding: '12px',
                background: '#0f2419',
                border: '1px solid #2d5a45',
                borderRadius: '4px',
                color: 'white',
                fontSize: '16px'
              }}
            />
          </div>

          <div style={{ marginBottom: '30px' }}>
            <label style={{ 
              display: 'block', 
              color: '#a0a0a0', 
              marginBottom: '8px',
              fontSize: '14px'
            }}>
              I am a...
            </label>
            <select
              value={role}
              onChange={(e) => setRole(e.target.value)}
              style={{
                width: '100%',
                padding: '12px',
                background: '#0f2419',
                border: '1px solid #2d5a45',
                borderRadius: '4px',
                color: 'white',
                fontSize: '16px'
              }}
            >
              <option value="Farmer">Farmer</option>
              <option value="Validator">Validator</option>
            </select>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '14px',
              background: loading ? '#888' : '#4ade80',
              color: '#0f2419',
              border: 'none',
              borderRadius: '4px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <p style={{ 
          color: '#888', 
          fontSize: '14px', 
          marginTop: '20px',
          textAlign: 'center'
        }}>
          Already have an account? <Link to="/login" style={{ color: '#4ade80' }}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}

export default Register;